import PropTypes from 'prop-types';

// For old API response, not GraphQL
const lineItemPropTypes = PropTypes.shape({
    complimentary: PropTypes.bool,
    description: PropTypes.string,
    discounts: PropTypes.array,
    id: PropTypes.string,
    member_id: PropTypes.number,
    meta_info: PropTypes.shape({
        // shared
        company_name: PropTypes.string,
        member_id: PropTypes.number,
        member_name: PropTypes.string,
        product_id: PropTypes.string,

        // membership
        dues_eligibility: PropTypes.shape({
            one_year_membership: PropTypes.shape({
                id: PropTypes.string,
                selected: PropTypes.bool,
            }),
            one_year_pac: PropTypes.shape({
                id: PropTypes.string,
                selected: PropTypes.bool,
            }),
            one_year_sic: PropTypes.shape({
                id: PropTypes.string,
                selected: PropTypes.bool,
            }),
            three_year_membership: PropTypes.shape({
                id: PropTypes.string,
                selected: PropTypes.bool,
            }),
            three_year_pac: PropTypes.shape({
                id: PropTypes.string,
                selected: PropTypes.bool,
            }),
            three_year_sic: PropTypes.shape({
                id: PropTypes.string,
                selected: PropTypes.bool,
            }),
        }),

        // event
        event_code: PropTypes.string,
        event_fee_auto_enroll: PropTypes.bool,
        event_function_code: PropTypes.string,
        event_functional_title: PropTypes.string,
        event_id: PropTypes.string,
        event_locale: PropTypes.string,
        event_name: PropTypes.string,
        event_registrant_class: PropTypes.string,
    }),
    name: PropTypes.string,
    price: PropTypes.number,
    product_id: PropTypes.string,
    product_type: PropTypes.string,
    prompts: PropTypes.array,
    quantity: PropTypes.number,
    subtotal: PropTypes.number,
    tax: PropTypes.number,
    tax_description: PropTypes.string,
});

export default lineItemPropTypes;
